import { useEffect, useState } from 'react';

import { useQueryGetPlacementsInVenue } from './useQuery';

import { FEATURE_FLAGS } from '~common';
import { checkEnabledFeatureFlag } from '~utils/common.util';

export const useSearchPlacements = ({ venueId }: { venueId?: string }) => {
  const [search, setSearch] = useState('');

  const getPlacementsQuery = useQueryGetPlacementsInVenue(
    {
      venueId: venueId,
    },
    {
      enabled: !!venueId,
    },
  );

  const placements = [
    ...(getPlacementsQuery.data?.nonPendingPlacements || []),
    ...(getPlacementsQuery.data?.pendingPlacementsRemovedStations || []),
  ];

  const onSearchPlacement = (searchString: string) => {
    setSearch(searchString);
  };

  const isEnableWebPinningSwapStation = checkEnabledFeatureFlag(
    FEATURE_FLAGS.ENABLE_WEB_PINNING_SWAP_STATION,
  );

  const filteredPlacements = placements.filter(
    (placement) =>
      placement.name.toLowerCase().includes(search.toLowerCase()) &&
      (isEnableWebPinningSwapStation || !placement.haveAssignedStation),
  );

  const [isHavingExistingPlacement, setIsHavingExistingPlacement] =
    useState(false);

  useEffect(() => {
    if (search === '' && isHavingExistingPlacement === false) {
      setIsHavingExistingPlacement(filteredPlacements.length > 0);
    }

    // in case venue id is null or undefined
    if (!venueId) {
      setIsHavingExistingPlacement(false);
    }
  }, [search, isHavingExistingPlacement, filteredPlacements.length, venueId]);

  return {
    placements: filteredPlacements,
    onSearchPlacement,
    isLoadingPlacements: getPlacementsQuery.isLoading,

    // this value indicates the number of existing placements in venue when search is empty
    isHavingExistingPlacement,
  };
};
